import Vue from 'vue';

const AudioPlayer = new Vue({
  data() {
    return {
      audio: undefined
    };
  },
  methods: {
    init(audioUrl, isSlowerPlayback = false) {
      if (this.audio) {
        this.audio.pause();
      }
      this.audio = new Audio(audioUrl);
      this.audio.playbackRate = isSlowerPlayback ? 0.6 : 1;
      this.audio.onended = this.playEnded;
    },
    play() {
      this.audio.play();
    },
    pause() {
      if (this.audio) {
        this.audio.pause();
      }
    },
    playEnded() {
      this.$emit('playEnded');
    },
    mute() {
      this.audio.volume = 0;
    }
  }
});
export default AudioPlayer;



// WEBPACK FOOTER //
// ./src/components/shared/audio.js